<template>
  <div class="protocolBanner">
    <!--<div id="carousel-example-generic" class="carousel slide" data-ride="carousel">-->
      <!--&lt;!&ndash; Wrapper for slides &ndash;&gt;-->
      <!--<div class="carousel-inner" role="listbox">-->
        <!--<div class="item active" >-->
          <!--<img  src='https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/protocol_banner.png' @click='jump(banner.bannerPictureJumpLink)' alt="一链网"/>-->
          <!--<div class="carousel-caption">-->
            <!--<h3><span>战略合作</span><span>信息共享</span></h3>-->
            <!--<p>企业采购战略合作伙伴、复星战略协议、更多的优质资源共享，平台提供了对战略采购、-->
              <!--集中采购、招标采购、询报价、电商式采购等多种采购模式与采购方式的全程式管控-->
              <!--的能力。实现企业真正的降本增效。</p>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="item" >-->
          <!--<img  src='https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/protocol_banner.png' @click='jump(banner.bannerPictureJumpLink)' alt="一链网"/>-->
          <!--<div class="carousel-caption">-->
            <!--<h3><span>战略合作</span><span>信息共享</span></h3>-->
            <!--<p>企业采购战略合作伙伴、复星战略协议、更多的优质资源共享，平台提供了对战略采购、-->
              <!--集中采购、招标采购、询报价、电商式采购等多种采购模式与采购方式的全程式管控-->
              <!--的能力。实现企业真正的降本增效。</p>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="conBox" >
      <div class="imgBox">
      <img  src='https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/protocol_banner.png' @click='jump(banner.bannerPictureJumpLink)' alt="一链网"/>
      </div>
      <div class="protocol-carousel">
        <!--<h3><span>战略合作</span><span>信息共享</span></h3>-->
        <h3>复星集团战略协议名录</h3>
        <p>企业采购战略合作伙伴、复星战略协议、更多的优质资源共享，平台提供了对战略采购、
          集中采购、招标采购、询报价、电商式采购等多种采购模式与采购方式的全程式管控
          的能力。实现企业真正的降本增效。</p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['bannerInfo'],
    data () {
      return {
      }
    },
    mounted () {
      this.bannerTime();
    },
    methods: {
      jump(url){
        window.location.href = url;
      },
      bannerTime () {
        $('.carousel').carousel({
          interval: 15000
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/protocolBanner/index.vue